import { Button } from "@mui/material"
import { Email, Home, East } from "@mui/icons-material"
import { H5, Body2 } from "../../../themes/typography"

export default function LogoutHomeScreen() {
    return (
        <div className="logout-home-screen-container">

            <div className="re-login-instructions-container">

                <div className="re-login-icon-title-container">
                    <div className="re-login-icon-container">
                        <Email color="tertiary" />
                    </div>

                    <div className="re-login-title-container">
                        <H5>
                            Re-login Details
                        </H5>
                    </div>
                </div>

                <div className="re-login-instructions">
                    <Body2 fontWeight={350}>
                        To continue scanning, re-login using the secure link sent to your email. Open the email on this device and follow the "Sign back in" link.
                    </Body2>
                </div>

            </div>

            <div className="re-login-instructions-container">

                <div className="re-login-icon-title-container">
                    <div className="re-login-icon-container">
                        <Home color="tertiary" />
                    </div>

                    <div className="re-login-title-container">
                        <H5>
                            Go to Homepage
                        </H5>
                    </div>
                </div>

                <div className="re-login-instructions">
                    <Body2 fontWeight={350}>
                        Alternatively, you can return to the homepage and explore other features of the application.
                    </Body2>
                </div>

                <div className="re-login-button-container">
                    <Button
                        variant="main"
                        href="/"
                        endIcon={<East />}
                        sx={{ textTransform: 'none', borderRadius: '1rem' }}
                    >
                        Go to Homepage
                    </Button>
                </div>

            </div>

        </div>
    )
}